/**
 * Report entity class
 */

import moment from 'moment'
import FileSaver from 'file-saver'

/**
 * ReportFactory
 * returns Report entity class
 *
 * @class ReportFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Report} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportFactory
 */
/* @ngInject */
export default function ReportFactory ($window, $http, Entity) {
  /* === Report class === */

  /**
   * Report model
   *
   * @class Report
   * @classdesc Report model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.Report} Report entity
   */
  function Report () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Report.prototype = Object.create(Entity.prototype)
  Report.prototype.constructor = Report

  /* === User instance methods & fields === */

  Object.assign(Report.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Report#
     * @type {Object}
     */
    _fields: {
      id: Number,
      deleted: Number,
      name: String,
      createdTime: moment,
      networks: [],
      createdBy: String,
      reportType: String // REPORT_TYPES
    },

    /**
     * url template
     *
     * @memberof models.Report#
     * @type {String}
     */
    _urlTemplate: 'api/reports/{{::id}}',

    /**
     * Export file by type
     *
     * @memberof models.Report#
     * @param type
     */
    _export (type) {
      $http.get(this._url + '\\export?format=' + type, {
        responseType: 'blob'
      }).then((response) => {
        FileSaver.saveAs(response.data, this.id + ' ' + moment(this.createdTime).format('DD-MM-YYYY HH-mm'))
      })
    },

    /**
     * Download report file
     *
     * @memberof models.Report#
     * @param type
     * @param {Boolean} exprt
     */
    _download (type, exprt = false) {
      if (exprt) {
        $http.get(this._url + '\\export', {
          responseType: 'blob'
        }).then((response) => {
          FileSaver.saveAs(response.data, this.id + ' ' + moment(this.createdTime).format('DD-MM-YYYY HH-mm'))
        })
      } else {
        $http.get(this._url + '\\download?format=' + type, {
          responseType: 'blob'
        }).then((response) => {
          FileSaver.saveAs(response.data, this.id + ' ' + moment(this.createdTime).format('DD-MM-YYYY HH-mm') + (response.data.type.includes('zip') ? ' ' + type : ''))
        })
      }
    }

  })

  /* === User static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(Report, Entity)
  Report._name = 'Report'
  Report.init()

  // permissions
  // Report.access = {
  //   view: 'viewReport',
  //   delete: 'deleteReport'
  // }

  return Report
}
